import { ProgressUpdateCard } from '../../../blocks/ProgressUpdateCard';
import { ProgressUpdate } from '../../../blocks/ProgressUpdateCard/types';
import { Button } from '../../../common/Button';
import { CheckInData } from '../types/types';
import { transformUpdate } from '../utils';

import { NoCheckInsMessage } from './NoCheckInsMessage';

export function ActionButton({
  variant,
  size,
  onCopy,
  children,
  className,
}: {
  variant: 'outline' | 'primary';
  size: 'xs' | 'sm' | 'md' | 'lg';
  onCopy: () => void;
  children: React.ReactNode;
  className?: string;
}): JSX.Element {
  return (
    <Button
      variant={variant}
      size={size}
      className={className}
      onClick={onCopy}
    >
      {children}
    </Button>
  );
}

export function CheckInSection({
  progressUpdates,
  hasShadow,
  title,
  handleEdit,
  handleDelete,
  showShadowFeatures,
  handleCopy,
}: {
  progressUpdates: ProgressUpdate[];
  hasShadow: boolean;
  title: string;
  handleEdit?: (update: ProgressUpdate) => void;
  handleDelete?: (update: ProgressUpdate) => Promise<void>;
  showShadowFeatures?: boolean;
  handleCopy?: (updates: CheckInData[]) => void;
}): JSX.Element {
  return (
    <div className={`flex flex-col gap-4 w-full  ${hasShadow ? 'flex-1' : ''}`}>
      <h2 className="flex justify-between items-start gap-1 text-xl font-regular leading-7 text-title">
        {title}
        {showShadowFeatures && (
          <ActionButton
            variant="outline"
            className="w-fit text-sm shrink-0"
            size="xs"
            onCopy={() =>
              handleCopy?.(
                progressUpdates.map((update) => transformUpdate(update)),
              )
            }
          >
            Copy All
          </ActionButton>
        )}
      </h2>
      {progressUpdates.length === 0 ? (
        <div className="flex flex-col items-center justify-center w-full text-center">
          <NoCheckInsMessage
            customMessage={showShadowFeatures ? 'No Check-ins yet.' : undefined}
          />
        </div>
      ) : (
        <div
          className={`flex flex-col p-2 gap-3 w-full h-full scrollbar-thin ${
            hasShadow
              ? 'rounded-lg overflow-y-auto shadow border border-gray-200'
              : ''
          }`}
        >
          {progressUpdates.map((update) => (
            <ProgressUpdateCard
              key={update.id}
              item={update}
              className="mb-1"
              showDescription
              onEdit={() => handleEdit?.(update)}
              onDelete={() => {
                handleDelete?.(update).catch(console.error);
              }}
              actionButton={
                showShadowFeatures ? (
                  <ActionButton
                    variant="primary"
                    size="xs"
                    className="w-fit text-sm"
                    onCopy={() => handleCopy?.([transformUpdate(update)])}
                  >
                    Copy
                  </ActionButton>
                ) : undefined
              }
              hideMenu={showShadowFeatures}
              hidePopover={hasShadow}
            />
          ))}
        </div>
      )}
    </div>
  );
}
